'use client';

import { c as _c } from "react/compiler-runtime";
import type { ConnectedWalletOperation } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
type ConnectedWalletCopyKey = Extract<keyof IntlMessages['onramp'], `connected_wallet_${string}`>;
const statusCopy: Readonly<Record<ConnectedWalletOperation['state'], readonly [ConnectedWalletCopyKey, ConnectedWalletCopyKey]>> = {
  wallet_widget: ['connected_wallet_checking', 'connected_wallet_checking_description'],
  submitted: ['connected_wallet_checking', 'connected_wallet_checking_description'],
  processing: ['connected_wallet_checking', 'connected_wallet_checking_description'],
  below_minimum: ['connected_wallet_below_minimum', 'connected_wallet_below_minimum_description'],
  under_review: ['connected_wallet_under_review', 'connected_wallet_under_review_description'],
  complete: ['connected_wallet_complete', 'connected_wallet_complete_description'],
  route_failed: ['connected_wallet_failed', 'connected_wallet_checking_description'],
  refund: ['connected_wallet_refund', 'connected_wallet_checking_description']
};
export function FundingConnectedWalletStatus(t0) {
  const $ = _c(24);
  const {
    operation,
    onTopUp
  } = t0;
  const t = useTranslations("onramp");
  const copy = statusCopy[operation.state];
  let t1;
  if ($[0] !== copy[0] || $[1] !== t) {
    t1 = t(copy[0]);
    $[0] = copy[0];
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h3 className="text-heading-sm">{t1}</h3>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== copy[1] || $[6] !== t) {
    t3 = t(copy[1]);
    $[5] = copy[1];
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <p className="mt-2 text-body text-foreground-secondary">{t3}</p>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div className="rounded-control bg-background-tertiary p-4 text-center">{t2}{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onTopUp || $[14] !== operation.state || $[15] !== t) {
    t6 = operation.state === "below_minimum" && onTopUp ? <AnimatedButton className="h-11 w-full" onClick={onTopUp}>{t("connected_wallet_top_up")}</AnimatedButton> : null;
    $[13] = onTopUp;
    $[14] = operation.state;
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== operation.state || $[18] !== t) {
    t7 = !["complete", "route_failed", "refund"].includes(operation.state) ? <ol className="flex flex-col gap-3 text-body"><li>✓ {t("connected_wallet_timeline_submitted")}</li><li>◌ {t("connected_wallet_timeline_checking")}</li><li>○ {t("connected_wallet_timeline_received")}</li></ol> : null;
    $[17] = operation.state;
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className="flex flex-col gap-4">{t5}{t6}{t7}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}